
import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { NetworkTableThingyActions } from "../actions/table_actions";
import {parameterset, testdataResponsePayloadInterface, updatedata} from "../typing/table_typing";
import { myfetchThunk } from "../../../app/myfetch";
import {masteruri} from "../../../config";
import { message } from "antd";




interface ResponsePayloadScanamster{
    data:{
        updates:updatedata[],
    }
}

export const requestDataFromAPI =() => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        dispatch(myfetchThunk(
            true,
            masteruri+"/Updates",
            {},
            "GET",
            (payload:ResponsePayloadScanamster) => {
                console.log(payload);
                 dispatch(
                     NetworkTableThingyActions.resetData(
                          {
                              data : payload.data.updates,
                          }
                      )
                  );
            },
            ()=>{}
        ) as any)
    }
}

export const requestUpdateActivationFromAPI =(payload:any) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{

         dispatch(myfetchThunk(
             true,
             masteruri+"/Updates/activate/"+payload,
            {payload},
             "POST",
             (payload:testdataResponsePayloadInterface) => {
                 message.success(payload.status);
                 // Reload the list after a successful activation.
                 //
                 // Without this the row keeps its "activate" button until the
                 // user navigates away and back: the release has been
                 // activated on the hub, the message says so, and the table
                 // still shows the old state. Nothing is broken, but the page
                 // contradicts the message it just displayed.
                 dispatch(requestDataFromAPI() as any);
             },
             (payload:any) => {
                 console.log("ERROR")
                 console.log(payload)
                 message.error(payload.status);
             },
         ) as any)
    }
}

/**
 * Withdraws a release (POST Updates/deactivate/<uuid>): spokes are no longer
 * offered it. Reloads the list afterwards, like activation.
 */
export const requestUpdateDeactivationFromAPI =(payload:any) => {
    return (
        dispatch:Dispatch<any>,
        getState:() => RootState
    )=>{
         dispatch(myfetchThunk(
             true,
             masteruri+"/Updates/deactivate/"+payload,
            {payload},
             "POST",
             (payload:testdataResponsePayloadInterface) => {
                 message.success(payload.status);
                 dispatch(requestDataFromAPI() as any);
             },
             (payload:any) => {
                 message.error(payload.status);
             },
         ) as any)
    }
}

/**
 * Archives one release (POST Updates/archive/<uuid>) or several at once
 * (POST Updates/archive with a list of ids; all or nothing). The hub answers
 * 409 for an active release; conflictText says so in the user's language.
 * Reloads the list afterwards.
 */
export const requestArchiveFromAPI =(uuids:readonly string[], conflictText:string) => {
    return (
        dispatch:Dispatch<any>,
        getState:() => RootState
    )=>{
         const single = uuids.length === 1;
         dispatch(myfetchThunk(
             true,
             masteruri + (single ? "/Updates/archive/" + uuids[0] : "/Updates/archive"),
             single ? {} : [...uuids],
             "POST",
             (payload:testdataResponsePayloadInterface) => {
                 message.success(payload.status);
                 dispatch(requestDataFromAPI() as any);
             },
             (failure:{status:number}) => {
                 if (failure.status === 409) message.error(conflictText);
                 dispatch(requestDataFromAPI() as any);
             },
         ) as any)
    }
}

/** Restores an archived release (POST Updates/unarchive/<uuid>); it stays inactive. */
export const requestUnarchiveFromAPI =(uuid:string) => {
    return (
        dispatch:Dispatch<any>,
        getState:() => RootState
    )=>{
         dispatch(myfetchThunk(
             true,
             masteruri+"/Updates/unarchive/"+uuid,
             {},
             "POST",
             (payload:testdataResponsePayloadInterface) => {
                 message.success(payload.status);
                 dispatch(requestDataFromAPI() as any);
             },
             () => {},
         ) as any)
    }
}

export const requestScanFromAPI =(posstraget:string, scanmaster:string, payload:parameterset) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        dispatch(myfetchThunk(
            true,
            masteruri+"/Scanmanager/"+posstraget+"/"+scanmaster,
            {payload},
            "POST",
            (payload:testdataResponsePayloadInterface) => {
                console.log(payload);
            },
            ()=>{}
        ) as any)
    }
}

export const requestRuleScanMasterFromAPI =(filter:string) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        // dispatch(myfetchThunk(
        //     true,
        //     masteruri+"/RuleScanmasters",
        //     {},
        //     "GET",
        //     (payload:ResponsePayloadScanamster) => {
        //         dispatch(
        //             NetworkTableThingyActions.setRuleScanmasterItem(
        //                 {
        //                     setScanMasterItem: payload.data.user,
        //                 },
        //             )
        //         )
        //         console.log(payload);
        //     },
        //     ()=>{}
        // ) as any)
    }
}



// export const requestDataDeletionFromAPI =(item:string) => {
//     return (
//         dispatch:Dispatch<any>, 
//         getState:() => RootState
//     )=>{       
//         dispatch(myfetchThunk(
//             true,
//             masteruri+"/PossibleTargets/"+item,
//             {},
//             "DELETE",
//             (payload:testdataResponsePayloadInterface[]) => {
//                 dispatch(
//                     NetworkTableThingyActions.resetData(
//                          {
//                              data : payload
//                          }
//                      )
//                  );
//             },
//             ()=>{}
//         ) as any)
//     }
// }

